import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import { domainLevelConfig } from "../../../../ui-config";
import { Typography, useTheme } from "@material-ui/core";
import { endSession, stopSession } from "redux/actions";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
}));

export default function NavBar({ showTimer }) {
  const classes = useStyles();
  const theme = useTheme();

  const history = useHistory();

  let time = useRef(null);
  let color = useRef(theme.palette.primary.main);

  const host = useSelector((state) => state.userReducer.host);
  const timer = useSelector((state) => state.touchless.timer);
  const logo = useSelector((state) => state.touchless.logo);
  const isLoading = useSelector((state) => state.touchless.isLoading);
  const themeData = useSelector((state) => state.touchless.theme);
  const dispatch = useDispatch();
  const {
    name,
    logo_url
  } = themeData || {};

  const hostConfig =
    domainLevelConfig[host] || domainLevelConfig["default"] || {};

  useEffect(() => {
    if (showTimer) {
      let minutes = Math.floor(timer / 60);
      let seconds = timer - minutes * 60;

      if (minutes < 10) {
        minutes = `0${minutes}`;
      }

      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      time.current = `${minutes}:${seconds}`;

      if (timer < 30) {
        color.current = "#d90001";
      }

      if (timer <= 0) {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const serial_no = urlParams.get("serial_no");

        dispatch(endSession());
        history.push(`/webstore/products?serial_no=${serial_no}`);
      }
    }
  }, [timer, dispatch, history, showTimer]);

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "center",
            position: "relative",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              // width: "68vw",
            }}
          >
            <div
              style={{
                height: 40,
                width: 150,
                display: "flex",
                alignItems: "center",
                paddingTop: 3,
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  backgroundImage: name!== "default" && logo_url !== "" ? `url(${logo_url})`:`url(${
                    logo || (!isLoading && (hostConfig.logo || hostConfig.navLogo))
                  })`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  height: "100%",
                  width: "100%",
                }}
              />
            </div>
          </div>
          {showTimer && (
            <Typography
              style={{ position: "absolute", right: 10, color: color.current }}
              variant="body1"
            >
              <b>{time.current} Left</b>
            </Typography>
          )}
        </Toolbar>
      </AppBar>
    </div>
  );
}
